import React from 'react';
import './styles.css'

class ButtonLoading extends React.Component {
    render() {
        return (
            <button
                type={this.props.type}
                style={this.props.style}
                className={`px-6 py-2  font-medium bg-${this.props.color}-600 text-${this.props.textColor || 'white'} border border-gray-300 shadow-sm rounded-lg hover:bg-${this.props.color}-700 flex items-center ${this.props.className}`}
                disabled={this.props.disabled ? this.props.disabled : this.props.loading}
                onClick={this.props.onClick}
            >
                {this.props.loading ?
                    <i className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true" />
                    :
                    <>
                        {this.props.icon && <i className={"mr-4 " + this.props.icon} />}
                    </>
                }
                {this.props.label}
            </button>
        )
    }

}

export default ButtonLoading;